export const getLoginUrl = (useMarketwebLogin:boolean, environment:string) => {

const environment_Production = "PRODUCTION";

const devAuthUrl = 'https://atportal.postnord.com/api/unified-login/backend/authorization?redirectionUrl=';
const prodAuthUrl = 'https://portal.postnord.com/api/unified-login/backend/authorization?redirectionUrl=';
const marketwebLoginUrl = '/login?returnUrl=';

if(useMarketwebLogin)
  {
    return marketwebLoginUrl;
  }
   else if (environment.toUpperCase() !== environment_Production) {
      return devAuthUrl;
    } else {
        return prodAuthUrl;
    } 
  };
